import { useQuery, useQueryClient, useMutation } from 'react-query'
import client, { deleteclient } from './api-client'

const queryConfig = {
    staleTime: 1000 * 60 * 60,
    cacheTime: 1000 * 60 * 60,
}

// api/plaguesparcel/?parcel_id=868&to_date=2021-12-02

async function fetchPlagues(parcel_id) {
    const data = await client(`plaguesparcel/?parcel_id=${parcel_id}`)
    return data
}

export function usePlagues(parcel_id) {
    return useQuery(['plaguesparcel', parcel_id], () => fetchPlagues(parcel_id), {
        enabled: false,
        refetchAllOnWindowFocus: false,
        ...queryConfig
    });
}

async function deletePlagueParameter(id) {
    await deleteclient(`plagueparameter/${id}/`)
}

export function useDeletePlagueParameter(id) {
    const queryClient = useQueryClient();

    return useMutation((id) => deletePlagueParameter(id), {
        onSuccess: (data, variables) => {
            queryClient.invalidateQueries(['plaguesuser'])
        },
    });
}
